<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-12 10:02:41
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-12-22 14:10:09
-->
<template>
  <div>
    <mobile v-if="device == 'm'" />
    <pc v-if="device == 'pc'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pc from './pc'
import mobile from './m'
export default {
  components: {
    pc,
    mobile
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['device', 'language'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  },
  destroyed () {
  }
}
</script>
